
import React, { useEffect, useState } from 'react'
import './UserManagement.css';
import '../../common/pillTabs.css';
import AllUserList from './AllUserList';
import UserContactedList from './UserContactedList';


const UserManagement = () => {
  
  const [activeComponent, setActiveComponent] = useState(0);

  const handleToggle = (index) => {
    setActiveComponent(index);
  };

  return (
    
    <div>
      
    <div className="pill-box" style={{ width: '300px' }}>
      <div
        className="pill-slider"
        style={{
          left: `calc(5px + ${activeComponent} * (100% - 10px) / 2)`,
          width: 'calc((100% - 10px) / 2)',
        }}
      />
      <button className={`pill-btn ${activeComponent === 0 ? 'active' : ''}`} onClick={() => handleToggle(0)}>
        All User List
      </button>
      <button className={`pill-btn ${activeComponent === 1 ? 'active' : ''}`} onClick={() => handleToggle(1)}>
        Contacted User List
      </button>
    </div>

    {activeComponent === 0 && <AllUserList />}
    {activeComponent === 1 && <UserContactedList />}
       </div>
  )
}

export default UserManagement

